// extracted by mini-css-extract-plugin
module.exports = {"pageLayout":"HX","mainContent":"IX","activeSidebar":"JX"};